import { DialogService, GridAction } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { FinalPresentation } from '../final-presentation-view.part';
import { FinalPresentationMarkRoadmapStatusDialog } from '../mark-roadmap-status-dialog/mark-roadmap-status.dialog';
import { FinalPresentationSetEventDialog } from '../set-event-dialog/set-event.dialog';
import { FinalPresentationMarkFinalPresentationStatusDialog } from '../mark-final-presentation-status-dialog/mark-final-presentation-status.dialog';
import { FinalPresentationSetDeckSubmittedDateDialog } from '../set-deck-submitted-date-dialog/set-deck-submitted-date.dialog';
import { FINAL_PRESENTATION_SCORE_COMPLETE, FINAL_PRESENTATION_SCORE_COMPLETE_LATE } from '@interfaces';
import { AccVentureDialog } from 'ui/widget';

export function getActions(dialogService: DialogService, accAreaService: AcceleratorAreaService) {

	const actions: GridAction<FinalPresentation>[] = [
		{
			iconClass: 'fa-regular fa-calendar-lines',
			label: 'Set Event',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const accVentureId = rows[0]?.accVentureId;
				if (accVentureId) {
					const finalEventId = rows[0]?.finalEventId;
					await dialogService.showCustom(FinalPresentationSetEventDialog, { data: { accVentureId, finalEventId } }, 400, 220);
				}
			}
		},
		{
			iconClass: 'fa-regular fa-calendar',
			label: 'Set Deck Submitted Date',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const hasFinalPresentationScore = rows[0]?.finalPresentationScore != undefined;
				if (hasFinalPresentationScore) {
					await dialogService.showMessage(`Cannot change Deck Submitted Date`, `Cannot change the Deck Submitted Date as the presentation status is already set.`)
				}
				else {
					const accVentureId = rows[0]?.accVentureId;
					if (accVentureId) {
						const deckSubmittedUTC = rows[0]?.deckSubmittedUTC;
						await dialogService.showCustom(FinalPresentationSetDeckSubmittedDateDialog, { data: { accVentureId, deckSubmittedUTC } }, 400, 220);
					}
				}
			}
		},
		// {
		// 	iconClass: 'fa-regular fa-list',
		// 	label: 'Mark Roadmap Status',
		// 	isEnabled: rows => !!rows.length && (rows[0]?.roadmapScore == undefined || rows[0]?.roadmapScore == null),
		// 	execute: async rows => {
		// 		const accVentureId = rows[0]?.accVentureId;
		// 		if (accVentureId) {
		// 			const roadmapScore = rows[0]?.roadmapScore;
		// 			const result = await dialogService.showCustom(FinalPresentationMarkRoadmapStatusDialog, { data: { accVentureId, roadmapScore } }, 400, 220);
		// 			if (result.id == 'save') {
		// 				const selectedRoadmapScore = result.callbackResult;

		// 				const confirm = await dialogService.confirm(
		// 					`Are you sure you want to Mark Roadmap Status as ${selectedRoadmapScore == 100 ? 'Complete' : 'Missed'}? This action cannot be undone.`,
		// 				);

		// 				if (confirm) {
		// 					await accAreaService.setVentureRoadmapScore(accVentureId, selectedRoadmapScore);
		// 				}
		// 			}
		// 		}
		// 	}
		// },
		{
			iconClass: 'fa-regular fa-list',
			label: 'Mark Presentation Status',
			isEnabled: rows => !!rows.length && (rows[0]?.finalPresentationScore == undefined || rows[0]?.finalPresentationScore == null),
			execute: async rows => {
				const accVentureId = rows[0]?.accVentureId;
				if (accVentureId) {
					const finalPresentationScore = rows[0]?.finalPresentationScore;
					const deckSubmittedUTC = rows[0]?.deckSubmittedUTC;
					const result = await dialogService.showCustom(FinalPresentationMarkFinalPresentationStatusDialog, { data: { accVentureId, finalPresentationScore, deckSubmittedUTC } }, 400, 220);
					if (result.id == 'save') {
						const selectedFinalPresentationScore = result.callbackResult;

						const confirm = await dialogService.confirm(
							`Are you sure you want to Mark Presentation Status as ${(selectedFinalPresentationScore == FINAL_PRESENTATION_SCORE_COMPLETE || selectedFinalPresentationScore == FINAL_PRESENTATION_SCORE_COMPLETE_LATE) ? 'Complete' : 'Missed'
							}? This action cannot be undone.`,
						);

						if (confirm) {
							await accAreaService.setVentureFinalPresentationScore(accVentureId, selectedFinalPresentationScore);
						}
					}
				}
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Open Venture',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const accVentureId = rows[0]?.accVentureId;
				if (accVentureId) {
					await dialogService.showCustom(AccVentureDialog, { data: { accVentureId } }, 900, 700);
					await accAreaService.reloadData(); // TODO: optimize to reload only if changes were made
				}
			}
		},
	];

	return actions;
}